import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { announcementApi } from 'src/Services/API';

const useAssetAnnouncements = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['asset-announcements', assetId],
    queryFn: () => announcementApi.findAllByAsset(assetId!),
    enabled: Boolean(assetId),
    staleTime: 60 * 1000,
  });
};

export default useAssetAnnouncements;
